import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';
import InputCheckbox from 'modules/_shared/components/InputCheckbox';
import movementTypes from 'modules/transactions/constants/movementTypes';

import { useRenumerationModal } from '../context/RenumerationModalContext';
import RangesView from './RangesView';

const RenumerationByClassMode: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useRenumerationModal();

  const isDisabledCheckbox =
    data.historyMovements.length > 0 || !data.selectedHoldingClassOption;

  const isDisabledSelector =
    data.historyMovements.length > 0 &&
    data.historyMovements.some(
      (movement) =>
        movement.movementType === movementTypes.ENTIRE_CLASS_RENUMERATION
    );

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="class-select-input">
          {t('SelectShareclassToFilter')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="class-select-input"
            value={data.selectedHoldingClassOption}
            onChange={actions.handleChangeHoldingClass}
            onFetchData={actions.handleFetchHoldingClassByTerm}
            placeholder={t('SearchClass')}
            minimumInputLength={1}
            noDataLabelKey="NoClassesHaveBeenFound"
            loadingLabelKey="LoadingClasses"
            errorLabelKey="ErrorLoadingClasses"
            defaultOptions={data.holdingClassOptions}
            isDisabled={isDisabledSelector}
          />
        </div>
      </div>

      <div className="form-group">
        <InputCheckbox
          id="isEntireClassRenumeration"
          label={t('RenumerateEntireClass')}
          checked={data.isEntireClassRenumeration}
          onChange={actions.handleChangeIsEntireClassRenumeration}
          disabled={isDisabledCheckbox}
        />
      </div>

      <RangesView />
    </>
  );
};

export default RenumerationByClassMode;
